import React from "react";
import Classes from "./styles/style.module.css";
import PeleIcon from "../PeleIcon";
import DiamondIcon from "../../images/icons/diamondIcon.png";
import ClandarIcon from "../../images/icons/calendar.svg";
import ClanderCheckIcon from "../../images/icons/calendar-tick.svg";
import WordGameIcon from "../../images/icons/wordgame.svg";

const QuestsListElement = ({
  title,
  subTitle,
  score,
  handleClick,
  isEvent,
  remaining,
  isWG,
}) => {
  const getIcon = () => {
    if (isEvent) {
      return remaining ? (
        <img src={ClanderCheckIcon} alt="Calandar-tick-icon" />
      ) : (
        <img src={ClandarIcon} alt="Calandar-icon" />
      );
    } else if (isWG) {
      return <img src={WordGameIcon} alt="wordgame-icon" />;
    } else {
      return <img src={DiamondIcon} alt="diamond-icon" />;
    }
  };

  return (
    <div className={Classes.questListElement} onClick={handleClick}>
      <div className={Classes.diamondImgContainer}>{getIcon()}</div>
      <div className={Classes.contentContainer}>
        <p>{title}</p>
        <p dangerouslySetInnerHTML={{ __html: subTitle }}></p>
        <p>{remaining ? "ظرفیت باقیمانده: " + remaining : null}</p>
      </div>
      {score ? (
        <>
          <p className={Classes.scoreText}>{score}</p>
          <PeleIcon className={"mr-2 mt-3"} />
        </>
      ) : null}
    </div>
  );
};

export default QuestsListElement;
